const SIDE_NAV_WIDTH = 56;
const CONTENT_INLINE_PADDING = 128;
const TABLE_HORIZONTAL_CHROME = SIDE_NAV_WIDTH + CONTENT_INLINE_PADDING;
const MIN_TABLE_CONTENT_WIDTH = 640;
function getProportionalColumnWidths(windowWidth, weights) {
  const availableWidth = Math.max(windowWidth - TABLE_HORIZONTAL_CHROME, MIN_TABLE_CONTENT_WIDTH);
  const totalWeight = weights.reduce((sum, weight) => sum + weight, 0);
  return weights.map(weight => Math.round(weight / totalWeight * availableWidth));
}
export function applyResponsiveColumnWidths(columns, windowWidth, weights) {
  const paddedWeights = columns.map((_, index) => {
    var _weights$index;
    return (_weights$index = weights[index]) !== null && _weights$index !== void 0 ? _weights$index : 1;
  });
  const widths = getProportionalColumnWidths(windowWidth, paddedWeights);
  return columns.map((column, index) => Object.assign({}, column, {
    width: widths[index]
  }));
}